import PartnerInvoiceContainer from './partner-invoice-container';

export default PartnerInvoiceContainer;
